// ajax模块
export default {
  'err404.tips': 'الأخبار التي تبحث عنها ليست موجودة. يرجى اختيار موضوع آخر. نحن في انتظارك هناك!'
};
